import { TAO_KOE, EN_KO, Render } from '../libs';
import { getCurrencyCode } from './currency';

// Either JSX or lodash - jsx is cleaner code
// lodash renders faster ( because its only manipulating strings )
// For now leave both alternatives.
// import renderCarousel from './templates/productcarousel.tpl.html';
import renderCarousel from './templates/productcarousel_item.tpl.html';
// import templateFn from './templates/productcarousel.jsx';

export default class DYCarouselItem {
	constructor( item ) {
		if ( 'Campaign' === item.type ) {
			this.type = 'Campaign';
			this.slotId = item.slotId;
		} else {
			this.type = 'Strategy';
			this.md = item.md;
			this.fallback = item.fallback;
			this.strId = item.strId;
		}

		this.data = this.convert( item );
	}

	convert( slot ) {
		// Get Item.
		const item = slot.item;

		item.deeplink = EN_KO.functions.make_link_relative( item.url );
		item.shortdescription = item.name;

		// Prices.
		item.oldpriceValue = this.convertToFloat( item.old_price );
		item.priceValue = this.convertToFloat( item.price );

		// Images.
		item.image = item.image_url;
		item.hoverimage = item.image_url2;

		// Top Badges.
		item.new = 'true' === String( item.new );
		item.sale = 'true' === String( item.sale ) || ( item.oldpriceValue && item.oldpriceValue !== item.priceValue );
		item.onlineonly = 'true' === String( item.onlineonly );

		// Other Badges.
		item.badges = this.parseDYBadges( item );

		// Coming Soon.
		item.coming_soon = item.coming_soon && String( item.coming_soon ) !== 'false';

		// Get Currency Code
		item.currency_code = getCurrencyCode();

		if ( item.sale ) {
			item.salesPercentage = Math.abs( Math.round( ( item.priceValue - item.oldpriceValue ) / item.oldpriceValue * 100 ) );
		}

		return item;
	}

	convertToFloat( number ) {
		if ( 'number' === typeof number ) {
			return number;
		}

		if ( 'undefined' === typeof number ) {
			return '';
		}

		return parseFloat( number.toString().replace( ',', '.' ).replace( '€', '' ).replace( 'CHF', '' ).trim() );
	}

	parseDYBadges( item ) {
		if ( Array.isArray( item.badges ) ) {
			return item.badges;
		}

		// Generate Badge Array.
		const badgeMap = window.ACL_BADGE_DEFS || {};
		item.badges = Object.keys( badgeMap ).map( ( key ) => {
			if ( 'true' !== String( item[ key ] ) ) {
				return false;
			}

			return badgeMap[ key ] ?? false;
		} )
			.filter( ( badge ) => !! badge )
			.toSorted( function( a, b ) {
				return Number( b.priority ) - Number( a.priority );
			} )
			.slice( 0, 3 );

		return item.badges;
	}

	renderPriceHtml( template ) {
		const item = this.data;
		return EN_KO.functions.render_product_price_html( {
			offer: item.priceValue,
			regular: item.sale ? item.oldpriceValue : 0,
			min: item.priceValue,
			max: item.priceValue,
			baseprice: 'recommendations' === template ? item.priceperunit : '',
			wrapperClass: 'mdl_productcarousel_item__price',
		} );
	}

	getTrackingData( index ) {
		// There is a typo there...
		const item = this.data;
		const category = item.categories[ item.categories.length - 1 ];

		return {
			'id': item.group_id,
			'name': item.name,
			'price': item.priceValue,
			'brand': item.brand,
			category,
			'list': document.location.pathname,
			'position': index || 0,
		};
	}

	getImage( imageUrl, width = 768, height = 1024, quality = 75 ) {
		let image = imageUrl;

		if ( width && height ) {
			image = image.replace( '-768_1024_75-', `-${ width }_${ height }_${ quality }-` );
		}

		return decodeURIComponent( image ).replace( /\s+/g, '-' );
	}

	getImageForType( imageUrl, type = 'default' ) {
		if ( 'recommendations' === type || 'chanel' === type ) {
			return this.getImage( imageUrl, 330, 440 );
		}

		return this.getImage( imageUrl, 192, 256 );
	}

	isAiImageUrl( imageUrl ) {
		return EN_KO.functions.is_ai_image_url( imageUrl );
	}

	escAttrOutput( itemAttr ) {
		return itemAttr.split( '&' ).join( '&amp;' ).split( '<' ).join( '&lt;' ).split( '"' ).join( '&quot;' ).split( "'" ).join( '&#39;' );
	}

	getSourceSet( imageUrl, type = 'default' ) {
		const image192 = this.getImage( imageUrl, 192, 256 );
		const image330 = this.getImage( imageUrl, 330, 440 );
		const image768 = this.getImage( imageUrl, 768, 1024 ); // eslint-disable-line no-unused-vars

		if ( 'recommendations' === type || 'chanel' === type ) {
			return [
				`${ image192 } 192w`,
				`${ image330 } 330w ,`,
			].join( ',' );
		}

		if ( 'crossselling' === type ) {
			return [
				`${ image192 } 192w`,
				`${ image192 } 330w`,
			].join( ',' );
		}

		return [
			`${ image192 } 192w`,
			`${ image192 } 330w`,
		].join( ',' );
	}

	isOnWishlist( userdata ) {
		const user = userdata?.data?.user;
		const wishlist = user.wishlist || [];

		const itemCount = wishlist.find( ( item ) => item.aid === this.data.sku )?.amt || 0;
		return itemCount > 0;
	}

	getWishlistLink( userdata ) {
		const user = userdata?.data?.user;

		if ( ! user?.loggedIn ) {
			return '/mein-konto/';
		}

		const params = new URLSearchParams( {
			'cl': 'account_noticelist',
			'fnc': 'addArticleToNoticeList',
			'aid': this.data.sku,
			'amt': this.isOnWishlist( userdata ) ? 1 : 0,
			'stoken': user.stoken,
		} );

		return '/index.php?' + params.toString();
	}

	addQueryParamsToUrl( url, params ) {
		// if URL is relative, we'll need to add a fake base
		const fakeBase = ! url.startsWith( 'http' ) ? 'http://fake-base.com' : undefined;
		const modifiedUrl = new URL( url || '', fakeBase );

		// add/update query params
		Object.keys( params ).forEach( function( key ) {
			if ( modifiedUrl.searchParams.has( key ) ) {
				modifiedUrl.searchParams.set( key, params[ key ] );
			} else {
				modifiedUrl.searchParams.append( key, params[ key ] );
			}
		} );

		// return as string (remove fake base if present)
		return modifiedUrl.toString().replace( fakeBase, '' );
	}

	render( options ) {
		return Render.render( 'productcarousel_item', {
			...options,
			'element': this,
		} );
	}
}

// Init.
TAO_KOE.ready( 'productcarousel-item.js', () => {
	// Add Template to Render items.
	Render.addTemplate( 'productcarousel_item', renderCarousel );
} );
